"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

require("./navbar.less");

function NavBar(props) {
  var classNames = ["nav-container"];

  if (props.fixed) {
    classNames.push("fixed");
  }

  return React.createElement("div", {
    className: classNames.join(" ")
  }, React.createElement("nav", {
    className: "bar bar--sm bar-1"
  }, props.children));
}

exports["default"] = NavBar;

function Logo(props) {
  return React.createElement("a", {
    className: "nav-logo",
    href: props.href || "/"
  }, React.createElement("img", {
    src: props.src
  }));
}

exports.Logo = Logo;

function Navs(props) {
  var children = React.Children.toArray(props.children).reverse().map(function (original, key) {
    return React.cloneElement(original, {
      key: key
    });
  });
  return React.createElement("div", {
    className: "navs"
  }, React.createElement("ul", null, children));
}

exports.Navs = Navs;

function NavItem(props) {
  return React.createElement("li", null, React.createElement("a", {
    href: props.href
  }, props.text));
}

exports.NavItem = NavItem;